import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import ReportViewer, {
  accountxReportUrl,
} from 'containers/DigitalReportModule/ReportViewer'
import { formatDashDate } from 'helpers/StringNumberFunction/FormatDate'
import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router'

export const APAdvanceLedgerReport = () => {
  const history = useHistory()
  //const { CompanyID, BankAccountID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const accountID = user.accountID
  let location = useLocation()
  const { CompanyID }: any = useParams()
  const editData = location?.state as any

  const parameters = [
    {
      name: 'accountid',
      value: accountID,
    },
    {
      name: 'companyid',
      value: editData?.CompanyID,
    },
    {
      name: 'startdocdate',
      value: editData?.StartDocDate
        ? formatDashDate(new Date(editData?.StartDocDate).toISOString())
        : null,
    },
    {
      name: 'enddocdate',
      value: editData?.EndDocDate
        ? formatDashDate(new Date(editData?.EndDocDate).toISOString())
        : null,
    },
    {
      name: 'starttrxndate',
      value: editData?.StartTrxnDate
        ? formatDashDate(new Date(editData?.StartTrxnDate).toISOString())
        : null,
    },
    {
      name: 'endtrxndate',
      value: editData?.EndTrxnDate
        ? formatDashDate(new Date(editData?.EndTrxnDate).toISOString())
        : null,
    },
    {
      name: 'creditortypeid',
      value: editData?.CreditorTypeID,
    },
    {
      name: 'creditoraccountid',
      value: editData?.CreditorAccountID,
    },
  ]

  const generatedurl = (reportName, parameters) => {
    let reporturl = reportName

    parameters?.map((x, index) => {
      const symbol = index === 0 ? '?' : '&'
      if (x?.value !== undefined)
        reporturl = reporturl + symbol + x?.name + '=' + x?.value
    })
    return reporturl
  }

  return (
    <>
      <MainHeader
        onClick={() =>
          history.push(
            `/digital-reports/account-payable/ap-advance-ledger/parameters`
          )
        }
        mainBtn="close"
        smTitle="Account Payable"
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Submenu' },
          { name: 'Parameters' },
          { name: 'Advance Ledger', current: true },
        ]}
        rightRouteSegments={[{ name: 'Report', current: true }]}
      />
      <ContentWrapper style={{ maxHeight: '100%' }}>
        {ReportViewer({
          url: generatedurl('APAdvanceLedgerReport', parameters),
          host: accountxReportUrl,
          excludedExportFormat: [],
        })}
      </ContentWrapper>
    </>
  )
}
